const emailOpenIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19">
      <g fill="none" fill-rule="evenodd" transform="translate(1 -1)">
        <g stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round" transform="translate(0 1.667)">
          <path d="M19.5833333,15.8333333 C19.5833333,16.5233333 19.0233333,17.0833333 18.3333333,17.0833333 L1.66666667,17.0833333 C0.976666667,17.0833333 0.416666667,16.5233333 0.416666667,15.8333333 L0.416666667,6.66666667 L10,0 L19.5833333,6.66666667 L19.5833333,15.8333333 Z"/>
          <polyline points="2.917 14.167 7.083 11.25 12.917 11.25 17.083 14.167"/>
          <path d="M19.5833333 6.66666667L14.5833333 10M.416666667 6.66666667L5.41666667 10"/>
        </g>
        <rect width="20" height="20"/>
      </g>
    </svg>

`;

export default emailOpenIcon;
